"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var CrudService_1 = __importDefault(require("../Core/CrudService"));
var entityName = 'planned_delivery_windows';
var prefix = 'merchant';
var baseRoute = "/".concat(prefix, "/").concat(entityName);
exports.Routes = {
    GET_BY_TEAM: "".concat(baseRoute, "?team_id={:teamId}"),
    GET_ALL: baseRoute,
    UPDATE: "".concat(baseRoute, "/{:id}"),
    BULK_DELETE: "".concat(baseRoute, "/mass_delete"),
    BULK_EDIT: "".concat(baseRoute, "/mass_update")
};
var PlannedDeliveryWindowsService = /** @class */ (function () {
    function PlannedDeliveryWindowsService(session) {
        this.service = new CrudService_1.default(session, entityName, prefix);
    }
    PlannedDeliveryWindowsService.prototype.load = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.get(id)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.planned_delivery_window];
                }
            });
        });
    };
    PlannedDeliveryWindowsService.prototype.loadAllWithoutTeam = function (startTime, endTime) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .get(exports.Routes.GET_ALL)
                            .setException('failed to load planned delivery windows without team')
                            .withQueryString({ start_time: startTime, end_time: endTime })
                            .invoke()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.planned_delivery_windows];
                }
            });
        });
    };
    PlannedDeliveryWindowsService.prototype.loadAllByTeam = function (teamId, startTime, endTime) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .get(exports.Routes.GET_BY_TEAM)
                            .setException("failed to load delivery windows from team ".concat(teamId))
                            .withRouteParams({ teamId: teamId })
                            .withQueryString({ start_time: startTime, end_time: endTime })
                            .invoke()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.planned_delivery_windows];
                }
            });
        });
    };
    PlannedDeliveryWindowsService.prototype.create = function (deliveryWindows) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.create(deliveryWindows)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.planned_delivery_windows];
                }
            });
        });
    };
    PlannedDeliveryWindowsService.prototype.update = function (id, plannedDeliveryWindow, recurrenceOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.update(id, __assign({ planned_delivery_window: plannedDeliveryWindow }, recurrenceOptions))];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.planned_delivery_window];
                }
            });
        });
    };
    PlannedDeliveryWindowsService.prototype.bulkUpdate = function (plannedDeliveryWindowsToEdit) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .post(exports.Routes.BULK_EDIT)
                            .setException('failed to edit planned delivery windows')
                            .withPayload(plannedDeliveryWindowsToEdit)
                            .invoke()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    PlannedDeliveryWindowsService.prototype.delete = function (id, recurrenceOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.delete(id, recurrenceOptions)];
            });
        });
    };
    PlannedDeliveryWindowsService.prototype.bulkDelete = function (plannedDeliveryWindowsToDelete) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .post(exports.Routes.BULK_DELETE)
                            .setException('failed to delete some of planned delivery windows')
                            .withPayload(plannedDeliveryWindowsToDelete)
                            .invoke()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.results];
                }
            });
        });
    };
    return PlannedDeliveryWindowsService;
}());
exports.default = PlannedDeliveryWindowsService;
//# sourceMappingURL=planned-delivery-windows-service.js.map